<template>
  <div class="dictionary-container">
    <el-input
      v-model="code"
      size="small"
      placeholder="字典項編碼"
      style="width: 200px; margin-right: 20px"
    ></el-input>
    <el-input
      v-model="name"
      size="small"
      placeholder="字典項名稱"
      style="width: 200px; margin-right: 20px"
    ></el-input>
    <el-select
      v-model="isUse"
      size="small"
      style="width: 200px; margin-right: 20px"
      :placeholder="$t('app.validation.select') + $t('app.enable')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-search"
      @click="getList()"
    ></el-button>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-plus"
      @click="handleNew()"
      >{{ $t("app.new") }}</el-button
    >
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column align="left" :label="$t('app.serialNumber')" prop="code">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <template v-for="col in column">
        <el-table-column
          :key="col.model"
          align="center"
          :label="col.label"
          :prop="col.model"
        >
          <template slot-scope="scope">
            <template>
              {{ scope.row[col.model] }}
            </template>
          </template>
        </el-table-column>
      </template>

      <el-table-column align="center" width="280" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            >{{ $t("app.edit") }}</el-button
          >
          <el-button type="danger" size="small" @click="handleDel(scope.row)">{{
            $t("app.delete")
          }}</el-button>
          <el-button size="small" type="success" @click="dicItem(scope.row)">{{
            $t("app.dicItem")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      :title="$t('app.delete')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $t("app.isDelete") + "(" + deleteItem + ")" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="deleteDic()"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <dic-modal ref="dicModal" @handleSuccess="getList"></dic-modal>
    <dic-item ref="dicItem"></dic-item>
  </div>
</template>

<script>
import DicItem from "./modules/DictionaryItem";
import DicModal from "./modules/DictionaryModal";
import { getPageList, del } from "@/api/systemManagement/dictionaryManagement";
import { delEmpty } from "@/utils/utils";
export default {
  components: {
    DicModal,
    DicItem,
  },
  data() {
    return {
      column: [
        { model: "typeCode", label: this.$t("app.dicCode") },
        { model: "code", label: this.$t("app.dicCode") },
        { model: "name", label: this.$t("app.dicName") },
        { model: "enable", label: this.$t("app.enable") },
        { model: "description", label: this.$t("app.description") }
      ],
      code: "",
      name: "",
      isUse: null,
      options: [
        {
          value: true,
          label: this.$t("app.isUse")
        },
        {
          value: false,
          label: this.$t("app.disable")
        },
      ],
      size: 10,
      currentPage: 1,
      total: 100,
      loading: false,
      dialogVisible: false,
      deleteItem: "",
      deleteItemType: "",
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getPageList(
        delEmpty({
          DictCode: this.code,
          DictText: this.name,
          IsUse: this.isUse,
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            typeCode: item.DictTypeCode,
            code: item.DictCode,
            name: item.DictText,
            enable: item.IsUse,
            description: item.Description,
            sort: item.SortNumber,
            child: item.Children,
          };
        });
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleEdit(index, row) {
      this.$refs.dicModal.edit(index, row);
    },
    handleDel(row) {
      this.dialogVisible = true;
      this.deleteItem = row.code;
      this.deleteItemType = row.typeCode;
    },
    handleNew() {
      this.$refs.dicModal.add();
    },
    dicItem(row) {
      this.$refs.dicItem.visible(row);
    },
    deleteDic() {
      del({
        DictTypeCode: this.deleteItemType,
        DictCode: this.deleteItem,
      }).then(() => {
        this.$message({
          message: this.$t("app.opeSuccess"),
          type: "success",
        });
        this.dialogVisible = false;
        this.getList();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dictionary-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
